import Vue from 'vue';
import VueI18n from 'vue-i18n';
import enLocale from 'element-ui/lib/locale/lang/en';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import locale from 'element-ui/lib/locale';
import Cookies from 'js-cookie';

Vue.use(VueI18n);

export default () => {
    const messages = {
        en: {
            cmsg: {
                site: "BIS Cloud",
                login: 'Sign In',
                hasAdmin: 'Has backend perm',
                home: 'Home',
                loginBtn: 'Sign In',
                errField: 'Please correct this field!',
                logout:'Logout',
                category:'Category',
                code:'Code',
                browserSupport:'Please use the Chrome browser or browsers based on the webkit core such as Firefox and Safari to get the best experience.',
                sales:'Sales',
                user:'User',
                snRule:'SN Rule',
                role:'Role',
                perm:'Perm',
                setPerm:'Set Perm',
                name:'Name',
                content:'Content',
                env:'ENV',
                app:'APP',
                domain:'Domain',
                cnName:'中文名',
                property:'Property',
                setRole:'Set Role',
                disable:'Disable',
                enable:'Enable',
                productLine:'Product Line',
                uniqueName:'Unique Name',
                type:'Type',
                order:'Order',
                nickName:'Nick Name',
                status:'Status',
                parent:'Parent',
                appAuth:'App Auth',
                more:'More',
                from:'From',
                to:'To',
                brandModel:'Brand Model',
                device:'Device',
                settings:'Settings',
                statistics:'Statistics',
                file:'File',
                noFile:'No File',
                noModel:'No Model',
                sn:'SN',
                all:'All',
                accountExist:'Your account exist already!',
                between:'Between',
                brandOem:'Brand & OEM',
                seriesModel:'Product series and models',
                fileName:'File Name',
                esn:'Encrypted SN',
                createOn:'Create On',
                createBy:'Create By',
                updateBy:'Update By',
                cases:'Cases',
                connections:'Connections',
                admins:'Admins',
                instituations:'Instituations',
                rememberPwd:'Remember Password',
                dentalGenerate:'Preview & Convert Trigger',
                preview3d:'Preview 3D Model Of',
                preview:'Preview',
                enName:'English name',
                uniqueCode:'Unique code',
                modelType:'Model type',
                seriesNumberRule:'Series number rule',
                seeMore:'See more',
                seePerms:'See perms',
                setSNPrefix:'Set series number prefix',
                downloadSrc:'Download Origin',
                download:'Download',
                triggerService:'Trigger Service',
                triggerActionDialogCT:'Are you sure to do action "Trigger Service" for {filename}?',
                downOrPreview:'Download & Preview 3D Data',
                noAccount:'No account? You can ',
                members:'Members',
                devices:'Devices maintain/bind',
                models:'Models',
                products:'Products',
                users:'Users',
                roles:'Roles',
                configurations:'Settings',
                signup:'Create new account',
                regHospital:'I am a hospital/clinic',
                regHospitalTitle:'Apply to settle in to become a hospital/clinic',
                applyNow:'Apply Now',
                regPersonalTitle:'Apply to become a user of doctor',
                regPersonal:'I am a doctor',
                regLabTitle:'Apply to settle in to become a lab',
                regLab:'I am a lab',
                set1DefaultAdmin:'Set up a default administrator account',
                pubRightSide: {
                    title:'At {title} Dental Cloud you can',
                    m1:'Set up and manage connections to labs, hospital/clinic, or user of doctor',
                    m2:'View and manage your cases',
                    m3:'View and manage your institution when adaptive permission supplied',
                    m4:'Manage your {title}profile'
                },
                orderNum: 'Order Num',
                doctor: 'Doctor',
                patient: 'Patient',
                lab: 'Lab',
                isBeb: 'Is protected',
                waitReceive: 'Wait Receive',
                receiveRefused: 'Receive Refused',
                canceled:'Canceled',
                closed:'Closed',
                finished:'Finished',
                waitDesign:'Wait Design',
                waitDesignConfirm:'Wait Design Confirm',
                waitShipping:'Wait Shipping',
                waitConfirmShipping:'Wait Confirm Shipping',
                designType:'Design type',
                designRequirement:'Design requirement',
                otherRequirement:'Other requirement',
                issuer:'Issuer',
                issue:'Issue',
                author:'Author',
                issueMessage:'Issue Message',
                reasonOrAttachLessOne:'Reason or Attach must exist less one!',
                contentAttachLessOne:'Content or Attach must exist less one!',
                caseActionDialogCT:'Are you sure to do action "{action}" for order {Id} issued by doctor {Doctor} for patient {PatientName} to Lab {Lab}?<p>Design Type:{DesignType}<span><br />Design requirement:{DesignOptions}<br/>Materials:{Materials}<br/>Tooths:{DentalNotation} {Tooths}</span><br/>{Notes}</p>',
                caseUploadDesignDialogCT:'Are you sure to do action "Upload Design" for order {Id} issued by doctor {Doctor} for patient {PatientName} to Lab {Lab}?<p>Design Type:{DesignType}<span><br />Design requirement:{DesignOptions}<br/>Materials:{Materials}<br/>Tooths:{DentalNotation} {Tooths}</span><br/>{Notes}</p>',
                caseRedoDesignDialogCT:'Are you sure to do action "Redo Design" for order {Id} issued by doctor {Doctor} for patient {PatientName} to Lab {Lab}?<p>Design Type:{DesignType}<span><br />Design requirement:{DesignOptions}<br/>Materials:{Materials}<br/>Tooths:{DentalNotation} {Tooths}</span><br/>{Notes}</p>',
                caseDeliveryDialogCT:'Are you sure to do action "Shipping" for order {Id} issued by doctor {Doctor} for patient {PatientName} to Lab {Lab}?<p>Design Type:{DesignType}<span><br />Design requirement:{DesignOptions}<br/>Materials:{Materials}<br/>Tooths:{DentalNotation} {Tooths}</span><br/>{Notes}</p>',
                waitAccept:'Wait Accept',
                refused:'Refused',
                refuse:'Refuse',
                sendingSMS:'Valid in {time} seconds',
                accept:'Accept',
                active:'Active',
                target:'Target',
                newChangeInstituation:'New/Change Instituation',
                memberName:'Member Name',
                member:'Member',
                hospital:'Hospital/Clinic',
                accepted:'Accepted',
                auditing:'Auditing',
                setAdmins:'Set Admins',
                newMember:'New Member',
                isAdmin:'Is Admin',
                beAdmin:'Be Admin',
                beMember:'Be Member',
                belongs:'Belongs',
                model:'Model',
                belongType:'Belong Type',
                owner:'Owner',
                usageType:'Usage Type',
                usageName:'Usage Name',
                usageSpec:'Usage Spec',
                sure: "Sure",
                cancel: "Cancel",
                newDevice:'New/Edit Device Info of bind or maintain',
                usageUser:'Usage User',
                dentalDeviceFormDesc:'Notes: Belong Instituation or Belong User must supply one.',
                deleteDeviceDialogDesc:'Are you sure to delete Device {sn}？',
                deleteDeviceDialogTitle:'Delete Device',
                editDeviceDialogDesc:'Are you sure to edit Device {sn}？',
                labSpec:'Lab Spec',
                memberActionDialog:'Are you sure to {action} for member {name}？',
                memberActionDialogResetPwd:'<br />Notes: default password is 8888 after reset！',
                mobileEmailLessOne:'Mobile or Email must supply one',
                memberFormDesc:'Notes: Mobile or Email must supply one for password reset, announce, etc. Default password is 888888.',
                other:'Other',
                setFactoryAdminDialog:'Are you sure to set admins for {name}',
                changeFactoryDialog:'Are you sure to change factory {name}',
                newConnection:'New Connection',
                connectionActionDialogCT:'Are you sure to {action} connection for {User}？',
                instituationsActionDialog:'Are you sure to {action} for {name}？',
                requirement:'Requirement',
                issueBy:'Issue By',
                needConfirm:'Need Confirm',
                downloadPreparing:'This download is preparing...',
                materials:'Materials',
                closeOrder:'Close Order',
                cancelOrder:'Cancel Order',
                confirmReceive:'Confirm Receive',
                refuseReceive:'Refuse Receive',
                uploadDesign:'Upload Design',
                confirmDesign:'Confirm Design',
                redoDesign:'Redo Design',
                shipping:'Shipping',
                confirmShipping:'Confirm Shipping',
                redoShipping:'Redo Shipping',
                tooths:'Tooths',
                shippingInfo:'Shipping info',
                designDatas:'Design Datas',
                otherDatas:'Other Datas',
                scanDatas:'Scan Datas',
                projectFiles:'Project Files',
                action:'Action',
                cancel:'Cancel',
                notes:'Notes',
                selectFile:'Select File',
                dropHereOr:'Drop file here or',
                attach:'Attach',
                account:'Account',
                seeRoles:'See roles',
                phone:'Mobile phone',
                regOn:'Register on',
                regBetween:'Register between',
                reason:'Reason',
                save:'Save',
                supplior:'Supplior',
                shippingNum:'Shipping Num',
                downClients:'Download Clients',
                smsCaptcha:'Please continue with valid captcha, mobile and code！',
                close:'Close',
                required:'Can not be empty!',
                emailRequired:'Must be a valid email format!',
                integerRequired:'Must be a valid integer format!',
                successAction:'Your action done successfully, page will redirect automatically after 3 seconds.',
                mting:'System is under maintaining, please retry later!',
                reset:'Reset',
                twoPwdMatch:'Password of twice must be match!',
                search:'Search',
                new:'New',
                change:'Change',
                delete:'Delete',
                forgotPwd:'Forgot Password',
                chPwd:'Change Password',
                resetPwd:'Reset Password',
                email: 'Email',
                resetpwbe: 'Reset Password By Email',
                resetpwbeHint: 'Please change password for {user} from below:',
                captcha: 'Captcha',
                byEmail: 'By Email',
                mobile: 'Mobile',
                smsCode: 'SMS Code',
                sendSMS: 'Send SMS',
                newPwd: 'New Password',
                newPwdAgain: 'New Password Again',
                byMobile: 'By Mobile',
                forgot: 'I forgot my password',
                forgotEmailHint: 'Please input your email as account, captcha, act following the guid in the email you received！',
                orBackTo:'Or back to ',
                password: 'Password',
                passwordAgain: 'Password again',
                setSNPrefixDesc: "Are you sure to set model {name}'s sn prefix?<br >Current has following sn prefix: <br /> {SNPrefix}",
                setSNPrefixHint: "Set SN prefix",
                setSNPrefixHint1: "in most cases, the last prefix should be -",
                setSNPrefixHint2: "be careful to delete or modify unless the prefix confirms that no device or subsequent need is added or used.",
                addr:'Addr.',
                setUserRole: "Set User Role",
                setUserRoleHint: "Are you sure to set roles for user \"{name}\"",
                setUserRoleSuccess: "Success: you have setted {name}'s roles!",
                roleName: "Role Name",
                source: "Source",
                aoralLevel:"Std. Err ",
                dogSerialNum:"Dog SN",
                cameraSerialNum:"Camera SN",
                lightSerialNum:"Light SN",
                scanSerialNum:"Scanner head SN",
                snLight:"Light Serial Num",
                serialScanner:"Scanner Serial Num",
                serialCalibration:"Calibration Serial Num",
                serialNumber: "Serial number",
                comments: "Comments",
                newProduct: "New product",
                editProductHintSuccess: "New product added success!",
                editProductNotValid: "Std. Err, Dog SN, Camera SN, Light SN, Scanner head SN can't be both empty!",
                editProductHint: "Note: product information can only be added, valid with last added!",
                uploadBetween:"Upload between",
                newRole: "New Role",
                editRole: "Edit Role",
                addRoleSuccess: "Success: you have added a role!",
                delRole: "Are you sure to delete role {name}?",
                delRoleHint: "Delete role",
                delRoleHintSuccess: "Success: you delete {name}!",
                setRolePermHintSuccess: "Success: you set role {name}'s perm!",
                setRolePermHint: "Are you sure to set perm for role {name}?",
                permName:"Perm name",
                systemParams: "System params",
                interfaceDoc: "CDN content",
                yes: "Yes",
                no: "No",
                add:'Add',
                contact:'Contacter',
                submit: 'Submit',
                countryCode: '+Code',
                support_email:'Support Email',
                copyright: 'Copyright© 2014-2021 ',
                apac: {
                    title: '',
                    company: '',
                    tel: '',
                    addr: ''
                },
                emea: {
                    title: '',
                    company: '',
                    tel: '',
                    addr: ''
                },
                americas: {
                    title: '',
                    company: '',
                    tel: '',
                    addr: ''
                }
            },
            ...enLocale
        },
        cn: {
            cmsg: {
                site: 'BIS Cloud',
                login: '登錄',
                hasAdmin: '有後台權限',
                loginBtn: '登錄',
                cancel:'取消',
                notes:'說明',
                selectFile:'選擇檔案',
                dropHereOr:'拖放檔案至這裡或',
                attach:'附件',
                account:'帳號',
                seeRoles:'查看擁有的角色',
                phone:'手機',
                regOn:'註冊時間',
                regBetween:'註冊時間',
                reason:'原因',
                save:'儲存',
                sure: "確認",
                cancel: "取消",
                accountExist:'您的帳號已經存在！',
                supplior:'物流',
                shippingNum:'物流單號',
                sendingSMS:'{time}秒內有效',
                browserSupport:'請使用Google Chrome、Firefox或Safari等瀏覽器獲取最佳體驗。',
                user:'用戶',
                role:'角色',
                home:'首頁',
                setPerm:'設置權限',
                category:'分類',
                code:'編碼',
                perm:'權限',
                content:'內容',
                env:'環境',
                domain:'域名',
                name:'名稱',
                cnName:'中文名',
                property:'性質',
                setRole:'設定角色',
                disable:'禁用',
                enable:'啟用',
                productLine:'產品線',
                uniqueName:'唯一名稱',
                app:'應用',
                appAuth:'應用授權',
                type:'類型',
                nickName:'暱稱',
                status:'狀態',
                order:'順序',
                parent:'上級',
                more:'更多',
                from:'從',
                to:'到',
                brandModel:'品牌型號',
                device:'設備',
                file:'檔案',
                noFile:'無檔案',
                noModel:'無型號',
                sn:'序號',
                all:'全部',
                between:'時間段',
                brandOem:'品牌',
                seriesModel:'系列型號',
                fileName:'檔案名稱',
                settings:'設置',
                statistics:'統計',
                createOn:'建立於',
                createBy:'建立者',
                updateBy:'更新者',
                cases:'案例',
                connections:'關連網',
                admins:'管理',
                instituations:'機構',
                rememberPwd:'記住密碼',
                downloadSrc:'下載原始檔案',
                download:'下載',
                triggerService:'觸發預覽和轉換檔案',
                triggerActionDialogCT:'您確認要為檔案{filename}"觸發預覽和轉換檔案"?',
                preview3d:'預覽模型',
                preview:'預覽',
                enName:'English name',
                uniqueCode:'唯一碼',
                modelType:'型號類型',
                seriesNumberRule:'序號前綴規則',
                seeMore:'更多',
                seePerms:'查看權限',
                setSNPrefix:'設定序號前綴規則',
                dentalGenerate:'觸發預覽和轉換',
                downOrPreview:'下載＆預覽模型',
                noAccount:'沒有帳號？您可以立即',
                members:'成員',
                devices:'設備資訊維護綁定',
                models:'產品型號管理',
                products:'產品資訊管理',
                users:'系統用戶',
                roles:'系統角色',
                configurations:'系統設定',
                signup:'註冊/申請',
                issue:'發佈',
                author:'作者',
                issueMessage:'發佈訊息',
                reasonOrAttachLessOne:'原因或附件至少要有一個！',
                contentAttachLessOne:'內容或附件至少要有一個！',
                caseActionDialogCT:'您确认要对医生{Doctor}为病人{PatientName}下给技工所{Lab}的订单{Id}进行"{action}"操作吗?<p>类型:{DesignType}<span><br />需求:{DesignOptions}<br/>材料:{Materials}<br/>牙齿:{DentalNotation} {Tooths}</span><br/>{Notes}</p>',
                caseUploadDesignDialogCT:'您确认要对医生{Doctor}为病人{PatientName}下给技工所{Lab}的订单{Id}进行"上传设计方案"操作吗?<p>类型:{DesignType}<span><br />需求:{DesignOptions}<br/>材料:{Materials}<br/>牙齿:{DentalNotation} {Tooths}</span><br/>{Notes}</p>',
                caseRedoDesignDialogCT:'您确认要对医生{Doctor}为病人{PatientName}下给技工所{Lab}的订单{Id}进行"要求重新设计"操作吗?<p>类型:{DesignType}<span><br />需求:{DesignOptions}<br/>材料:{Materials}<br/>牙齿:{DentalNotation} {Tooths}</span><br/>{Notes}</p>',
                caseDeliveryDialogCT:'您确认要对医生{Doctor}为病人{PatientName}下给技工所{Lab}的订单{Id}进行"发货"操作吗?<p>类型:{DesignType}<span><br />需求:{DesignOptions}<br/>材料:{Materials}<br/>牙齿:{DentalNotation} {Tooths}</span><br/>{Notes}</p>',
                waitAccept:'待確認',
                refused:'拒絕',
                refuse:'拒絕',
                downloadPreparing:'下載正在準備中，請稍等！',
                accept:'接受',
                active:'活躍的',
                target:'目標',
                newChangeInstituation:'新建/修改機構',
                memberName:'成員名稱',
                member:'成員',
                hospital:'醫院/診所',
                accepted:'通過',
                auditing:'審核中',
                setAdmins:'設定管理員',
                newMember:'新建成員',
                isAdmin:'是否管理員',
                beAdmin:'設為管理员',
                beMember:'設為成員',
                belongs:'歸屬機構',
                model:'型號',
                belongType:'歸屬類型',
                owner:'擁有人',
                usageType:'使用類型',
                usageName:'使用方名稱',
                newDevice:'新建/修改設備維護和綁定資訊',
                usageSpec:'指定使用方',
                usageUser:'使用人',
                dentalDeviceFormDesc:'注意：歸屬方必須是機構或是用戶之一。',
                deleteDeviceDialogDesc:'您確認要刪除設備{sn}嗎？',
                deleteDeviceDialogTitle:'刪除設備',
                editDeviceDialogDesc:'您確認要修改設備{sn}嗎？',
                labSpec:'指定下單牙技所',
                memberActionDialog:'您確認要對成員{name}進行"{action}"操作嗎？',
                memberActionDialogResetPwd:'<br />注意: 重設後的預設密碼為888888',
                mobileEmailLessOne:'手機或EMail至少提供一個！',
                memberFormDesc:'注意: 手機或EMail至少提供一個，用於取回密碼、接收通知等操作。預設密碼為888888。',
                other:'其他',
                setFactoryAdminDialog:'您確認要為{name}設定管理員嗎？',
                changeFactoryDialog:'您確認要修改{name}嗎？',
                newConnection:'新建關連網',
                connectionActionDialogCT:'您確認要對使用者{User}的關連進行"{action}"操作嗎？',
                instituationsActionDialog:'您確認要對組織{name}進行"{action}"操作嗎？',
                regHospital:'我是醫院/診所',
                set1DefaultAdmin:'設置1個預設的管理員帳號',
                regPersonal:'我是醫師',
                regLab:'我是牙技所',
                regHospitalTitle:'申請入駐成為醫院/診所',
                applyNow:'立即申請',
                regPersonalTitle:'申請成為醫師用戶',
                regLabTitle:'申請入駐成為牙技所',
                pubRightSide: {
                    title:'在{title}，你可以',
                    m1:'與牙技所、醫院/診所、醫師使用者建立關連',
                    m2:'管理您的案例/訂單',
                    m3:'管理您的組織，如果您有足夠的權限',
                    m4:'管理您的{title}帳戶資訊'
                },
                orderNum: '訂單編號',
                doctor: '醫師',
                patient: '患者',
                lab: '牙技所',
                isBeb: '是加密檔案',
                waitReceive: '待接單',
                receiveRefused: '拒絕接單',
                issuer: '發佈方',
                canceled:'已取消',
                closed:'已關閉',
                finished:'已完成',
                waitDesign:'待設計',
                waitDesignConfirm:'待設計確認',
                waitShipping:'待發貨',
                waitConfirmShipping:'待收貨',
                designType:'類型',
                designRequirement:'需求',
                otherRequirement:'其他需求',
                requirement:'需求',
                issueBy:'下單人',
                needConfirm:'需要確認',
                materials:'材料',
                closeOrder:'關閉訂單',
                cancelOrder:'取消訂單',
                confirmReceive:'確定接單',
                refuseReceive:'拒絕接單',
                uploadDesign:'上傳設計方案',
                confirmDesign:'確認設計方案',
                redoDesign:'要求重新設計',
                shipping:'發貨',
                confirmShipping:'確認發貨',
                redoShipping:'要求重新發貨',
                tooths:'牙位',
                shippingInfo:'物流資訊',
                designDatas:'設計檔案',
                otherDatas:'其他',
                scanDatas:'掃描檔案',
                projectFiles:'專案文件',
                action:'操作',
                downClients:'下載客戶端',
                errField:'請修正該項錯誤！',
                close:'關閉',
                smsCaptcha:'請輸入驗證碼、手機號碼繼續！',
                required:'不能為空！',
                emailRequired:'必須是有效的EMail格式！',
                integerRequired:'必須是有效的數字格式！',
                successAction:'您已經操作成功，3秒後本頁面將自動跳轉。',
                mting:'伺服器正在維護中，請稍後再試！',
                twoPwdMatch:'2次密碼必需要一致！',
                reset:'重置',
                search:'搜索',
                new:'新建',
                change:'修改',
                delete:'刪除',
                forgotPwd: '忘記密碼',
                chPwd: '修改密碼',
                logout: '退出系統',
                resetpwbe: '通過EMail重置密碼',
                resetpwbeHint: '請從下面為{user}修改密碼：',
                email: 'EMail',
                byEmail: '通過EMail',
                mobile: '手機',
                captcha: '驗證碼',
                byMobile: '通過手機',
                forgot:'忘記密碼',
                resetPwd:'重設密碼',
                password:'密碼',
                passwordAgain:'確認密碼',
                addr:'地址',
                add:'加入',
                setSNPrefixDesc: "確定要設定型號{name}的序號前綴嗎?<br>目前序號前缀:<br/>{SNPrefix}",
                setSNPrefixHint: "設定序號前缀",
                setSNPrefixHint1: "在大多數情形下，前缀應該以-結尾",
                setSNPrefixHint2: "如需要删除或修改請確保沒有任何設備或是子序列加入或使用該前缀",
                setUserRole: "設定用戶角色",
                setUserRoleHint: "確認要修改用戶{name}的權限嗎?",
                setUserRoleSuccess: "成功設定用户{name}的權限!",
                roleName: "角色名稱",
                source: "未授權權限",
                aoralLevel:"標準偏差",
                dogSerialNum:"Dongle序號",
                cameraSerialNum:"相機序號",
                lightSerialNum:"光機序號",
                scanSerialNum:"掃描探頭序號",
                snLight:"光機序號",
                serialScanner:"口掃機序號",
                serialCalibration:"標定儀序號",
                serialNumber: "序號",
                comments: "備註",
                newProduct: "加入產品資訊",
                editProductHintSuccess: "加入產品資訊成功！",
                editProductNotValid: "標準偏差, Dongle序號, 相機序號, 光機序號, 掃描探頭序號這些不能同時為空！",
                editProductHint: "注意：產品資訊只能加入不能刪除，以最後加入的資訊為準！",
                uploadBetween: "上傳期间",
                newRole: "加入角色",
                editRole: "修改角色",
                addRoleSuccess: "您已經成功加入了1個角色！",
                delRole: "您確認要删除角色{name}嗎?",
                delRoleHint: "删除角色",
                delRoleHintSuccess: "您已經成功删除角色{name}!",
                setRolePermHintSuccess: "您已經成功設定角色{name}的權限!",
                setRolePermHint: "您確認要为角色{name}設定權限嗎?",
                permName: "權限名稱",
                systemParams: "系統設定",
                interfaceDoc: "CDN接口内容配置",
                yes: "是",
                no: "否",
                contact:'聯絡人',
                submit: '提交',
                smsCode: '簡訊驗證碼',
                sendSMS: '發送簡訊',
                newPwd: '新密码',
                newPwdAgain: '確認新密碼',
                forgotEmailHint:'請提交上述表單，並且按照收到的EMail內容進行操作！',
                orBackTo: '或回到',
                countryCode:'國家',
                support_email:'客服EMail',
                copyright: '版權所有© 2014-2021 ',
                apac: {
                    title: '',
                    company: '',
                    tel: '',
                    addr: ''
                },
                emea: {
                    title: '',
                    company: '',
                    tel: '',
                    addr: ''
                },
                americas: {
                    title: '',
                    company: '',
                    tel: '',
                    addr: ''
                }
            },
            ...zhLocale
        }
    }
    var lang = Cookies.get("lang") || "cn";
    let i18n = new VueI18n({
        locale: lang,
        messages
    });
    locale.i18n((key, value) => i18n.t(key, value));
    return i18n;
};